module.exports = __webpack_public_path__ + "media/images/icon/icons8-Upload-370e74507b6c1430aba4d9aaa6333da0.png";